'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = '2';
var width = 384;
var height = 512;
var aliases = [];
var unicode = '32';
var svgPathData = 'M48 64c0-13.3 10.7-24 24-24l186.9 0c55.9 0 101.1 45.3 101.1 101.1 0 40.5-24.1 77-61.3 93L143 300.8c-38.2 16.4-63 54-63 95.6l0 35.6 248 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L56 480c-13.3 0-24-10.7-24-24l0-59.6c0-60.8 36.2-115.8 92.1-139.7L279.8 190c19.5-8.4 32.2-27.6 32.2-48.8 0-29.3-23.8-53.1-53.1-53.1L72 88C58.7 88 48 77.3 48 64z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.fa2 = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;